import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CookieService } from 'ngx-cookie-service';
import { Observable, throwError } from 'rxjs';
import { size } from 'underscore';
import { environment } from '../../environments/environment';
import { ApiResponse } from '../bean/ApiResponse';

@Injectable({ providedIn: 'root' })
export class AuthService {

    jwtHelper: JwtHelperService = new JwtHelperService();
    private refreshHttp: HttpClient;

    constructor(private cookieService: CookieService, private handler: HttpBackend, private router: Router) {
        this.refreshHttp = new HttpClient(this.handler);
    }

    setAccessToken(token: string): void {
        const domain = environment.production ? '.sandbox.co.in' : 'localhost';
        this.cookieService.set('SESSIONID', token, 1, '/', domain, true, 'Strict');
    }

    setRefreshToken(token: string): void {
        const domain = environment.production ? '.sandbox.co.in' : 'localhost';
        this.cookieService.set('REFRESHSESSIONID', token, 30, '/', domain, true, 'Strict');
    }

    getAccessToken(): string {
        return this.cookieService.get('SESSIONID');
    }

    getIssuer(): string | null {
        if (this.getAccessToken() != null && this.getAccessToken() != '') {
            let jwtToken = this.jwtHelper.decodeToken(this.getAccessToken())
            return jwtToken['iss']
        }
        return null
    }

    getRefreshToken(): string {
        return this.cookieService.get('REFRESHSESSIONID');
    }

    clearSessionAndRedirectToLogin(redirectParam?: string): void {
        this.clearSession();
        this.redirectToLogin(redirectParam);
    }

    redirectToLogin(redirectParam?: string): void {
        const queryParams = redirectParam ? { redirect: redirectParam } : {};
        this.router.navigate(['/login'], { queryParams });
    }

    clearSession(): void {
        const domain = environment.production ? '.sandbox.co.in' : 'localhost';
        this.cookieService.delete('SESSIONID', '/', domain, true, 'Strict');
        this.cookieService.delete('REFRESHSESSIONID', '/', domain, true, 'Strict');
    }

    refreshSession(): Observable<ApiResponse<any>> {
        const refreshToken = this.getRefreshToken();
        if (!refreshToken) {
            return throwError(() => new Error('Refresh token not available'));
        }
        const url = `${environment.auth_services_endpoint}/authorize`;
        return this.refreshHttp.post<ApiResponse<any>>(url, { refresh_token: refreshToken });
    }

    isAuthenticated(): boolean {
      try {
        const accessToken = this.getAccessToken();
        let token = accessToken.split('.');
        if (
          token &&
          size(token) == 3 &&
          this.jwtHelper.decodeToken(accessToken) &&
          !this.jwtHelper.isTokenExpired(accessToken) &&
          this.getIssuer()?.includes(environment.token_issuer)
        ) {
          return true;
        }
      } catch (error) {
        return false;
      }
      return false;
    }
}


